<div style="height: 550px;">
  <form [formGroup]="SettingsForm">
    <div class="col-lg-12">
      <div class="mb-3 row">
        <fieldset>
          <legend>Basic Settings</legend>
        </fieldset>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <div class="col-lg-2">
          <span>Name:</span>
        </div>
        <div class="col-lg-4">
          <input type="text" pInputText style="width: 250px;" [formControl]="name" />
        </div>
        <div class="col-lg-2">
          <input type="checkbox" [formControl]="enabled" />
          <span class="uv-checkbox-label">Enabled</span>
        </div>
      </div>
    </div>
    <div class="col-lg-8">
      <div class="mb-3 row">
        @if (name.hasError('required')) {
          <div class="col-lg-8 alert alert-danger">
            This value is required
          </div>
        }
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <div class="col-lg-2">
          <span>Response Test(s):</span>
        </div>
        <div class="col-lg-2">
          <select [formControl]="responseTests" (change)="enableDisableControls()">
            <option value="0">Ping Only</option>
            <option value="1">Ping + SNMP</option>
            <option value="2">SNMP Only</option>
          </select>
        </div>
        <div class="col-lg-4">
          <input id="checkUpTime" type="checkbox" [formControl]="checkUpTime" />
          <span class="uv-checkbox-label">Check SNMP / sysUpTime</span>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <fieldset>
          <legend>Ping / ICMP Settings</legend>
        </fieldset>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <div class="col-lg-1">
          <span>Timeout:</span>
        </div>
        <div class="col-lg-4">
          <input type="number" pInputText style="width: 70px;" [formControl]="timeout" />
          <span class="ping-settings-control">(in milliseconds)</span>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        @if (timeout.hasError('required')) {
          <div class="alert alert-danger">
            This value is required
          </div>
        }
        @if (timeout.hasError('minValue') || timeout.hasError('maxValue')) {
          <div class="alert alert-danger">
            This value must be in the range 250 - 25000
          </div>
        }
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <div class="col-lg-1">
          <span>Retries:</span>
        </div>
        <div class="col-lg-2">
          <input type="number" pInputText style="width: 70px;" [formControl]="retries" />
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        @if (retries.hasError('required')) {
          <div class="alert alert-danger">
            This value is required
          </div>
        }
        @if (retries.hasError('minValue') || retries.hasError('maxValue')) {
          <div class="alert alert-danger">
            This value must be in the range 0 - 10
          </div>
        }
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <fieldset>
          <legend>Monitor Thresholds / Latency, Round-Trip Time (RTT)</legend>
        </fieldset>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <div class="col-lg-6">
          <input type="checkbox" [formControl]="useThresholds" (change)="enableDisableControls()" />
          <span class="uv-checkbox-label">Use Round-Trip Time (RTT) Thresholds</span>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <div class="col-lg-1">
          <span>Critical:</span>
        </div>
        <div class="col-lg-7">
          <input type="number" pInputText style="width: 85px;" [formControl]="criticalThreshold" />
          <span class="ping-settings-control">ms (>= enters critical state)</span>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        @if (criticalThreshold.hasError('required')) {
          <div class="alert alert-danger">
            This value is required
          </div>
        }
        @if (criticalThreshold.hasError('minValue') || criticalThreshold.hasError('maxValue')) {
          <div class="alert alert-danger">
            This value must be in the range 100 - 1000000
          </div>
        }
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        <div class="col-lg-1">
          <span>Warning:</span>
        </div>
        <div class="col-lg-7">
          <input type="number" pInputText style="width: 85px;" [formControl]="warningThreshold" />
          <span class="ping-settings-control">ms (>= enters warning state)</span>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="mb-3 row">
        @if (warningThreshold.hasError('required')) {
          <div class="alert alert-danger">
            This value is required
          </div>
        }
        @if (warningThreshold.hasError('minValue') || warningThreshold.hasError('maxValue')) {
          <div class="alert alert-danger">
            This value must be in the range 0 - 1000000
          </div>
        }
      </div>
    </div>
  </form>
</div>
